import { creators } from './remove'
import { creators as passwordCreators } from './password'

export const add = (history, params) => () =>
    history.push(`/${params.domain}/mail/alias/add`)

export const password = passwordCreators.password
export const remove = creators.remove
